// Copyright (c) 2018 Deere & Company

import * as busyCounter from './busy-counter';
import actions from '../actions-list';
import {getLatestPerUnitMeasurements} from '../repositories';

export const readLatestPerUnitMeasurements = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const latestPerUnitMeasurements = await getLatestPerUnitMeasurements(pin);

            dispatch({
                latestPerUnitMeasurements,
                type: actions.UPDATE_LATEST_PER_UNIT_MEASUREMENTS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetLatestPerUnitMeasurements = () =>

    dispatch =>

        dispatch({
            type: actions.RESET_LATEST_PER_UNIT_MEASUREMENTS
        });



// WEBPACK FOOTER //
// ./src/shared/action-creators/latest-per-unit-measurements.js